var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg77(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "50px",
    viewBox: "0 0 49 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5994 50C25.4423 50 25.2853 50 25.1282 49.8433L0.314103 26.9592C0.157051 26.8025 0 26.6458 0 26.3323C0 26.1756 0 25.8621 0.157051 25.7053L22.6154 0.31348C22.7724 0.15674 22.9295 0 23.2436 0C23.4006 0 23.7147 0 23.8718 0.15674L48.6859 23.0408C48.8429 23.1975 49 23.3542 49 23.6677C49 23.8245 49 24.1379 48.8429 24.2947L26.3846 49.6865C26.0705 49.8433 25.7564 50 25.5994 50ZM2 26.2517L25.676 48L47 23.9048L23.324 2L2 26.2517Z",
    id: "Shape",
    fill: "#1D1D1D",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg77);
export default __webpack_public_path__ + "static/media/77.be9c83deccd39efe15e165e1ae7c3f05.svg";
export { ForwardRef as ReactComponent };